import { useMatch } from "react-router-dom";

/**
 * This hook returns true if the user is currently in the portal.
 *
 * @returns boolean
 */
export const useIsInsidePortal: () => boolean = () =>
  !!useMatch("portal/add-device/*");
